import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import ButtonDisable from "../../partials/other/ButtonDisable";

export default function AddTickets() {
  const [tagFileAttachment, setTagFileAttachment] = useState([]);

  const AddTicketAttachment = () => {
    const tagsExampleTicketAttachment = (
      <div className="py-2">
        <input
          type="file"
          name="file"
          accept=".png, .jpeg,.jpg,.txt, .pdf,.doc, .docx"
          className="form-control"
        />
      </div>
    );

    setTagFileAttachment([...tagFileAttachment, tagsExampleTicketAttachment]);
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="درخواست پشتیبانی جدید" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body" id="add-ticket">
              <form>
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                  />
                </div>

                <div className="form-group col-12 col-sm-8 col-md-4">
                  <label>دسته بندی</label>
                  <select id="category" className="form-control">
                    <option value="17">پشتیبانی</option>
                    <option value="18">مدیریت حساب</option>
                    <option value="19">مالی</option>
                    <option value="20">اسکریپت</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>متن</label>
                  <textarea
                    className="form-control"
                    name="text"
                    id="text"
                    rows="12"
                  ></textarea>
                </div>

                <div className="row form-group">
                  <div className="col-sm-12">
                    <label>ضمیمه ها</label>
                  </div>

                  <div className="col-sm-3 col-sm-push-9">
                    <span
                      className="btn btn-default btn-block"
                      onClick={AddTicketAttachment}
                    >
                      <i className="fa fa-plus"></i>
                      افزودن موارد دیگر
                    </span>
                  </div>

                  <div className="col-sm-9 col-sm-pull-3">
                    <div className="pb-2">
                      <input
                        type="file"
                        name="file"
                        accept=".png, .jpeg,.jpg,.txt, .pdf,.doc, .docx"
                        className="form-control"
                      />
                    </div>
                    <div id="fileUploadsContainer">{tagFileAttachment}</div>
                  </div>

                  <div className="col-xs-12 ticket-attachments-message text-muted">
                    پسوند های مجاز: .png, .jpeg,.jpg,.txt, .pdf,.doc, .docx
                  </div>
                </div>
                <ButtonDisable
                  buttonTagHtml={
                    <span className="btn btn-success opacity-50">ارسال</span>
                  }
                />
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
